import React, { useState } from 'react';
import { Button, Box, Grid, Card } from '@mui/material';
import { RawDataService } from 'services/rawDataService';

export const Rawdata = () => {
  const mastersService = new RawDataService();

  const [loading, setLoading] = useState(false);

  const downloadXLS = (csvData: string, filename: string) => {
    const blob = new Blob([csvData], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fnDownloadLeaseData = async () => {
    setLoading(true);
    try {
      const response = await mastersService.FetchLeaseData();
      if (response) {
        // const timestamp = new Date().toISOString().slice(0, 19).replace(/[-:]/g, '');
        downloadXLS(response, `LeaseRawData.xls`);
      }
    } catch (error) {
      console.error('Error fetching lease data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fnDownloadAuditData = async () => {
    setLoading(true);
    try {
      const response = await mastersService.FetchAuditData();
      if (response) {
        // const timestamp = new Date().toISOString().slice(0, 19).replace(/[-:]/g, '');
        downloadXLS(response, `AuditRawData.xls`);
      }
    } catch (error) {
      console.error('Error fetching audit data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ p: 3 }}>
        <Grid container spacing={2} sx={{ maxWidth: '83.33%' }}>
          <Grid item xs={12} xl={3} lg={6} md={6} sm={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={fnDownloadLeaseData}
            >
              Download Lease Data
            </Button>
          </Grid>
          <Grid item xs={12} xl={3} lg={6} md={6} sm={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={fnDownloadAuditData}
            >
              Download Audit Data
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default Rawdata;